module.exports = __webpack_public_path__ + "img/ys_bj_5.839329bb.png";